import { useState, useEffect } from "react";
import { SharedHeader, SharedFooter, PageHero, Breadcrumb, NAVY, ORANGE } from "../../components/site/SharedLayout";
import { getCareer } from "../../services/api";
import useScrollToHash from "../../hooks/useScrollToHash";
import PageLoader from "../../components/site/PageLoader";
import SEO from "../../components/SEO";
export function CareersPage() {
  useScrollToHash();

  const [careerData, setCareerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    const fetchCareer = async () => {
      try {
        const data = await getCareer();
        setCareerData(data);
      } catch (err) {
        // silently fail
      } finally {
        setLoading(false);
      }
    };

    fetchCareer();
  }, []);

  if (loading) return <PageLoader />;
  if (!careerData) return <PageLoader />;
const seo = careerData?.seo || {};

  const jobs = careerData.jobs || [];
  const filters = [
    "All",
    ...new Set(jobs.map((job) => job.category).filter(Boolean)),
  ];
  const filtered =
    activeFilter === "All"
      ? jobs
      : jobs.filter((j) => j.category === activeFilter);

  return (
    <>
  <SEO
    title={seo.title}
    description={seo.description}
    canonical={seo.canonical}
    robots={seo.robots}
    keywords={seo.keywords}
    ogTitle={seo.ogTitle}
    ogDescription={seo.ogDescription}
    ogImage={seo.ogImage}
    twitterTitle={seo.twitterTitle}
    twitterDescription={seo.twitterDescription}
    twitterImage={seo.twitterImage}
    author="GLS Pharma"
  publisher="GLS Pharma"
  />
    <div style={{ fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif", margin: 0, padding: 0, color: "#222" }}>
      <SharedHeader />

      <Breadcrumb items={[{ label: "Home", path: "/" }, { label: "Careers", path: "/careers" }]} />
      <PageHero
  label={careerData.hero?.small_heading}
  title={careerData.hero?.main_heading}
  subtitle={careerData.hero?.description}
  bgImage={careerData.hero?.image?.url}
/>

      {/* Job Openings */}
      <section id="job-openings" style={{ padding: "70px 80px", background: "#f5f7fb", scrollMarginTop: 80 }}>
        <div className="product-portfolio-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 30 }}>
          <div>
            <div style={{ color: ORANGE, fontWeight: 700, fontSize: 12, letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>{careerData.section.subtitle}</div>
            <h2 style={{ fontSize: 36, fontWeight: 800, color: NAVY, margin: 0 }}>{careerData.section.title}</h2>
          </div>
          <div style={{ fontSize: 14, color: "#667" }}>{filtered.length} positions found</div>
        </div>

        {/* Filters */}
        <div className="product-chip-row" style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 30 }}>
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActiveFilter(f)}
              style={{ padding: "8px 18px", border: `2px solid ${activeFilter === f ? NAVY : "#dde4ef"}`, background: activeFilter === f ? NAVY : "#fff", color: activeFilter === f ? "#fff" : "#555", borderRadius: 20, fontSize: 13, fontWeight: 600, cursor: "pointer" }}
            >
              {f}
            </button>
          ))}
        </div>

        {/* Jobs List */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {filtered.map((job) => (
            <div
              key={job.id}
              className="job-row"
              style={{ background: "#fff", border: "1px solid #e5ecf9", borderRadius: 16, padding: "24px 28px", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "0 4px 14px rgba(0,0,0,0.04)" }}
            >
              <div>
                <div style={{ fontWeight: 700, color: NAVY, fontSize: 20, marginBottom: 8 }}>{job.title}</div>
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                  <span style={{ color: "#667", fontSize: 18 }}>🏢 {job.department}</span>
                  <span style={{ color: "#667", fontSize: 18 }}>📍 {job.location}</span>
                  <span style={{ color: "#667", fontSize: 18 }}>⏱️ {job.experience}</span>
                  <span style={{ background: "#eef9f4", color: "#0f766e", fontWeight: 700, fontSize: 12, padding: "3px 10px", borderRadius: 8 }}>{job.employment_type}</span>
                </div>
              </div>
              {job.apply_url ? (
                <a
                  href={job.apply_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ background: NAVY, color: "#fff", borderRadius: 10, padding: "12px 24px", textDecoration: "none", fontWeight: 600, fontSize: 14, flexShrink: 0 }}
                >
                  Apply Now →
                </a>
              ) : (
                <button
                  disabled
                  style={{ background: "#ccc", color: "#fff", border: "none", borderRadius: 10, padding: "12px 24px", fontWeight: 600, fontSize: 14, cursor: "not-allowed", flexShrink: 0 }}
                >
                  Apply Now
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Spontaneous Application */}
        <div className="spontaneous-cta" style={{ marginTop: 40, background: `linear-gradient(120deg, #0a1f4e, ${NAVY})`, borderRadius: 20, padding: "36px 44px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h3 style={{ color: "#fff", fontWeight: 700, fontSize: 36, margin: "0 0 8px" }}>{careerData.cta.title}</h3>
            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 18, margin: 0 }}>{careerData.cta.description}</p>
          </div>
          <a
            href={careerData.cta.button_link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ background: ORANGE, color: "#fff", borderRadius: 10, padding: "14px 28px", textDecoration: "none", fontWeight: 700, fontSize: 15, flexShrink: 0 }}
          >
            {careerData.cta.button_text}
          </a>
        </div>
      </section>

      <SharedFooter />
    </div>
    </>
  );
}

export default CareersPage;
